/** 与移动端 `loginRemember.js` 键名一致 */
export const LOGIN_USERNAME_KEY = 'login_username'
export const LOGIN_PASSWORD_KEY = 'login_password'
export const LOGIN_REMEMBER_KEY = 'login_remember'

export function getStoredRemember() {
  try {
    return localStorage.getItem(LOGIN_REMEMBER_KEY) === '1'
  } catch {
    return false
  }
}

export function getStoredLoginUsername() {
  try {
    return localStorage.getItem(LOGIN_USERNAME_KEY) || ''
  } catch {
    return ''
  }
}

export function getStoredLoginPassword() {
  try {
    return localStorage.getItem(LOGIN_PASSWORD_KEY) || ''
  } catch {
    return ''
  }
}

export function persistLoginRemember(username, password, remember) {
  try {
    if (remember) {
      localStorage.setItem(LOGIN_USERNAME_KEY, username)
      localStorage.setItem(LOGIN_PASSWORD_KEY, password)
      localStorage.setItem(LOGIN_REMEMBER_KEY, '1')
    } else {
      localStorage.removeItem(LOGIN_USERNAME_KEY)
      localStorage.removeItem(LOGIN_PASSWORD_KEY)
      localStorage.removeItem(LOGIN_REMEMBER_KEY)
    }
  } catch {
    // ignore
  }
}
